import { MutationTree } from 'vuex'
import { IProductsState, IPlan, IProduct } from '@/@types'

const mutations: MutationTree<IProductsState> = {
  PASS_TYPES_UPDATED: (state, passTypes: Array<object>) => {
    state.passTypes = passTypes
  },
  SELECTED_PRODUCT_TYPE_UPDATED: (state, productType: string) => {
    state.selectedProductType = productType
  },
  AVAILABLE_PLANS_UPDATED: (state, plans: Array<IPlan>) => {
    state.availablePlans = plans
  },
  AVAILABLE_CERTIFICATIONS_UPDATED: (state, certifications: Array<IProduct>) => {
    state.availableCertifications = certifications
  },
  AVAILABLE_LIVE_VIRTUAL_TRAININGS_UPDATED: (state, liveVirtualTrainings: Array<IProduct>) => {
    state.availableLiveVirtualTrainings = liveVirtualTrainings
  },
  LIVE_VIRTUAL_TRAINING_DISCOUNT_UPDATED: (state, liveVirtualTrainingDiscount: number) => {
    state.liveVirtualTrainingDiscount = liveVirtualTrainingDiscount
  },
  AVAILABLE_BOOTCAMPS_UPDATED: (state, bootcamps: Array<IProduct>) => {
    state.availableBootcamps = bootcamps
  },
  ONE_EXCLUSIVE_PLAN_UPDATED: (state, isOnePlanAvailable: Boolean) => {
    state.isOnePlanAvailable = isOnePlanAvailable
  },
}

export default mutations
